(function () {
  document.querySelectorAll('[data-contact-lola]').forEach(function (section) {
    initReveal(section);
    initResponsiveMedia(section);
  });

  function initReveal(section) {
    var revealEls = section.querySelectorAll('[data-contact-lola-reveal]');
    if (!revealEls.length) return;

    if (!('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    revealEls.forEach(function (el) {
      observer.observe(el);
    });
  }

  // Same lazy-loading pattern as heromain-lola/video-lola: the day/night
  // images sit inertly inside <template> tags (never parsed as live DOM,
  // never fetched) until this checks the current theme and clones only
  // the winning one into the real DOM — so only one image ever actually
  // downloads, regardless of which theme the visitor is in. A
  // MutationObserver reacts live if the visitor toggles day/night
  // without a page reload.
  function initResponsiveMedia(section) {
    var mediaContainer = section.querySelector('[data-contact-lola-media]');
    if (!mediaContainer) return;

    var dayTemplate = mediaContainer.querySelector('template[data-contact-lola-media-theme="day"]');
    var nightTemplate = mediaContainer.querySelector('template[data-contact-lola-media-theme="night"]');
    if (!dayTemplate) return;

    var liveEl = null;
    var lastKey = null;

    function currentTheme() {
      var isNight = document.documentElement.getAttribute('data-theme') === 'night';
      return isNight && nightTemplate ? 'night' : 'day';
    }

    function insertWinner() {
      var themeKey = currentTheme();
      if (themeKey === lastKey) return;

      var winningTemplate = themeKey === 'night' ? nightTemplate : dayTemplate;

      if (liveEl) {
        liveEl.remove();
      }

      var fragment = winningTemplate.content.cloneNode(true);
      var wrapper = document.createElement('div');
      wrapper.style.display = 'contents';
      wrapper.appendChild(fragment);

      mediaContainer.appendChild(wrapper);
      liveEl = wrapper;
      lastKey = themeKey;
    }

    var themeObserver = new MutationObserver(insertWinner);
    themeObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme']
    });

    insertWinner();
  }
})();
